// Cliente de /v1/images/remove-background (marca de agua: quitar fondo del logo).
// Se llama UNA vez al configurar — nunca en cada descarga.

import { atlasBackendFetch } from './atlasBackend';

export async function postRemoveBackground(imageUrl: string): Promise<string> {
  const res = await atlasBackendFetch('/v1/images/remove-background', { image_url: imageUrl });
  const body = (await res.json().catch(() => null)) as { url?: string; error?: string } | null;
  if (!res.ok || !body?.url) {
    throw new Error(body?.error || 'No se pudo quitar el fondo del logo. Probá de nuevo.');
  }
  return body.url;
}
